import { render, staticRenderFns } from "./CmgLoadingPepper.vue?vue&type=template&id=8d2d0f76&scoped=true&lang=pug&"
import script from "./cmg-loading-pepper.ts?vue&type=script&lang=ts&"
export * from "./cmg-loading-pepper.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoadingPepper.vue?vue&type=style&index=0&id=8d2d0f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2d0f76",
  null
  
)

export default component.exports